import React, { useContext, useEffect, useState } from 'react';
import dayjs from 'dayjs';
import { DateTime } from "luxon";
import styled from 'styled-components';
import ButtonTextCustom from '../elements/ButtonTextCustom';
import SelectCustom from '../elements/SelectCustom';
import InputCustom from '../elements/InputCustom'; 
import TextareaCustom from '../elements/TextareaCustom';
import InputCheckboxCustom from '../elements/InputCheckboxCustom';  
import LabelCustom from '../elements/LabelCustom';  
import ModalImage from '../elements/Modals/ModalImage';
import ActionBox from '../elements/ActionBox';
import ScheduleDateTimeRange from '../elements/Dialogs/ScheduleDateTimeRange';
import Confirmation from '../elements/Dialogs/Confirmation';
import Segmentation from '../elements/Dialogs/Segmentation';
import ButtonCustom from '../elements/ButtonCustom';
import FormTopMessage from '../elements/FormTopMessage';
import LoaderComponent from '../elements/LoaderComponent';
import FormData from './FormData';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { RiErrorWarningLine } from "react-icons/ri";

import { getNameLanguage,
         validateOnlyIntegers } from '../../helpers/functions';
import { BiSolidDownArrow } from "react-icons/bi";


import { FormatListNumberedIcon,
         CountIcon,
         CoursesMenuIcon,
         CalendarMonthIcon,
         SegmentarionIcon,
         FilterAltIcon,
         LanguageIcon } from '../../helpers/icons';

import { ContentContext,
         ConfigurationContext } from '../../context';

import { useTranslation } from 'react-i18next';

const WrapperStyled = styled.div`
    display: flex;
    width: 100%;
    justify-content: flex-start;
    flex-direction: column;
    .content_form{
        .inner_form{
            width: 100%;
        }
    }
    .content_form.show{
        display: flex;
    }
    .content_form.hide{
        display: none;
    }
    .box_lang{
        &.error{
            border: 1px solid ${props => `rgb(${props.panColors.red})`}!important;

            .head_form_lang{
                
                >.title{
                    .icon{
                        svg{
                            fill: ${props => `rgb(${props.panColors.red})`}!important;
                        }
                    }
                    .text{
                        color: ${props => `rgb(${props.panColors.red})`}!important;
                    }
                }
            }
        }
        &.multilang{
            box-sizing: border-box;
            padding: 0px 30px 0px;
            background-color: ${props => `rgb(${props.panColors.light_white})`};
            border: 1px solid ${props => `rgb(${props.panColors.light_white})`};
            margin-bottom: 20px;
            &.open{
                padding: 0px 30px 50px;
            }
            .head_form_lang{
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                box-sizing: border-box;
                padding: 20px 0 20px 0;
                
                >.title{
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    .icon{
                        svg{
                            width: 40px;
                            height: 40px;
                        }
                    }
                    .text{
                        font-size: 22px;
                        line-height: 22px;
                        font-weight: 700;
                        color: ${props => `rgb(${props.panColors.dots})`};
                        margin-left: 10px;
                    }
                }
            }
        }
    }

    .box_form{
        display: grid; 
        grid-template-columns: repeat(2, 1fr);
        gap: 50px;
        .box_column{
            .action_box_evaluation{
                margin-top: 50px;
            }
            .media_slides{
                margin-top: 30px;
                .no_multimedia_content{
                    box-sizing: border-box;
                    padding: 10px 15px 10px 15px;
                    width: 100%;
                    border: 1px dashed ${props => `rgb(${props.panColors.middle_gray})`};
                    color: ${props => `rgb(${props.panColors.dark_gray})`};
                    font-weight: 600;
                }
            }
        }
        &.show{
            display: grid;
        }
        &.hide{
            display: none;
        }
    }
    .box_evaluation{
        &.show{
            display: flex;
        }
        &.hide{
            display: none;
        }
    }
    .box_fields{
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        width: 100%;
        margin-bottom: 40px;
        .vigency_warning_text{
            //font-style: italic;
            display: flex;
            align-items: center;
            margin-top: 20px;
            p{
                margin: 0;
                padding: 0;
                font-size: 13px;
                line-height: 13px;
                font-weight: 600;
                color: rgb(108, 108, 153);
            }
            .icon{
                display: flex;
                margin-right: 5px;
                color: #eed202;
                font-size: 22px;
                line-height: 22px;
            }
        }
        .action_box_segmentation{
            margin-bottom: 30px;
        }
        .retries{
            margin-bottom: 20px;
            .label_retries{
                margin-bottom: 15px;
            }
            .field_can_repeat{
                margin-bottom: 10px;
            }
            .field_can_repeat_failure{
                margin-bottom: 10px;
            }
            .field_can_repeat_success{
                margin-bottom: 10px;
            }
        }
        >.title{
            color: ${props => `rgb(${props.panColors.black})`};
            font-size: 18px;
            font-weight: 600;
            margin-bottom: 20px;
        }
        >.field{
            display: flex;
            flex-direction: column;
            width: 100%;
            margin-bottom: 25px;
            :last-child{
                margin-bottom: 0;
            }
        }
        .field_description_long{
            margin-bottom: 0!important;
            textarea{
                height: 160px;
            }
        }
        .field_description_short{
            margin-bottom: 0!important;
            textarea{
                height: 120px;
            }
        }
        .bottom_textarea{
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            width: 100%;

            font-size: 14px;
            margin-top: 5px;
            font-weight: 700;
            color: ${props => `rgb(${props.panColors.dark_gray})`};
            &.error{
                color: ${props => `rgb(${props.panColors.red})`};
            }
        }
        .box_field_description_long,
        .box_field_description_short{
            width: 100%;
            margin-bottom: 25px!important;

            .error{
                color: ${props => `rgb(${props.panColors.red})`};
            }
        }
        .field_double{
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            width: 100%;
            .field{
                width: calc(50% - 10px);
            }
        }
        .field_single{
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            width: 100%;
            .field{
                width: 100%;
            }
            &.field_date_block{
                width: 100%;
                display: flex;
                flex-direction: column;
                margin-top: 20px;
                .label_label_activate_at{
                    margin-bottom: 5px;
                }
                .datetime_activate_at{
                    width: 100%;
                    &.error{
                        >.MuiInputBase-root{
                            border: 1px solid red;
                        }
                    }
                }
                >.field{
                    margin-bottom: 10px;
                }
            }
        }
    }
    .box_cover_image{
        display: flex;
        flex-direction: row;
        margin-bottom: 25px;
        width: 100%;
        
        .image,
        .image_thumb{
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            width: 300px;
            height: 300px;
            overflow: hidden;
            img{
                float: left;
                width: 100%;
            }
            &.error{
                border: 2px solid ${props => `rgb(${props.panColors.red})`};
            }
        }
        .image_thumb{
            background-color: ${props => `rgb(${props.panColors.middle_gray})`};
            .icon{
                width: 120px;
                height: 120px;
                svg{
                    float: left;
                    width: 100%;
                }
            }
        }
        
        .add_image{
            display: flex;
            flex-direction: column;
            margin-left: 20px;
            align-items: flex-start;
            .bt_add_image{
                padding: 0;
                >.text{
                    margin-left: 0;
                }
            }
            .bt_delete_image{
                padding: 0;
                margin-top: 10px;
            }
            .aclaration_bt_add_image{
                font-size: 12px;
                line-height: 14px;
                font-weight: 700;
                color: ${props => `rgb(${props.panColors.dark_gray})`};
                margin-top: 10px;
            }
        }
    }
    .add_aditional_information{
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        margin-bottom: 30px;
        .bt_add_more_info{
            display: flex;
            flex-direction: row;
            align-self: flex-start;
            padding: 0;
            margin-bottom: 30px;
        }
        .aditional_information_el{ 
            margin-bottom: 10px;
        }
        &.show{
            display: flex;
        }
        &.hide{
            display: none;
        }
    }
    .actions{
        display: flex;
        flex-direction: row;
        justify-content: flex-start;

        .bt_submit{

        }
        .bt_program_activation{
            margin-left: 10px;
        }
        .bt_cancel{
            margin-left: 10px;
        }
    }
    
`

const Form = (props) => {

    const { t } = useTranslation();

    const { panColors,
            userCountrySelected } = useContext(ConfigurationContext);
    
    const { basicData,
            uploadFile,
            getByPassImageUploadRoute } = useContext(ContentContext);
            
    const { scope,
            lang = null,
            contentByLang, 
            setContentByLang,
            handleStartLoadEvaluation, 
            handleCancel,
            setInitLoadEvaluation } = props;

    const [ openModalImage, setOpenModalImage ] = useState(false);
    
    const [ croppedImage, setCroppedImage ] = useState(null);
    const [ uploadRoute, setUploadRoute ] = useState(null);
    const [ questionQuantityEval, setQuestionQuantityEval ] = useState([]);
    const [ questionQuantityToload, setQuestionQuantityToload ] = useState([]);
    const [ openScheduleDateTimeRange, setOpenScheduleDateTimeRange ] = useState(false);
    const [ startDate, setStartDate ] = useState("");
    const [ endDate, setEndDate ] = useState("");
    const [ vigencyDateError, setVigencyDateError ] = useState(false);
    const [ vigencyDataLoaded, setVigencyDataLoaded ] = useState(true);
    const [ timezone, setTimezone ] = useState(dayjs.tz.guess());
    const [ timezoneError, setTimezoneError ] = useState(false);
    
    const [ coverImage, setCoverImage ] = useState(null);
    const [ loadingForm, setLoadingForm ] = useState(false);
    const [ segmentationOpen, setSegmentationOpen ] = useState(false);
    const [ segments, setSegments ] = useState([]);
    const [ segmentsError, setSegmentsError ] = useState(false);
    const [ confirmationOpen, setConfirmationOpen ] = useState(false);
    const [ noSegments, setNoSegments ] = useState(false);
    const [ haveErrorForm, setHaveErrorForm ] = useState(false);
    const [ errorFormMessage, setErrorFormMessage ] = useState({top: "Faltan los datos remarcados", bottom: "Corrige información faltante o erronea marcada"});
    const [ langHaveError, setLangHaveError ] = useState([]);
    const [ showLanguage, setShowLanguage ] = useState(null);
    const [ countActualQuestions , setCountActualQuestions ] = useState(null);
    const [ dateBlockError, setDateBlockError ] = useState(false);
    const [ blockDate, setBlockDate ] = useState("");
    
    const formStyle = {background_color: `rgba(${panColors.white}, 1)`,
                       border_color: `rgba(${panColors.middle_gray}, 1)`};

    const handleFormElementChange = (name, value) => {
        if(name !== 'timezone' ){
            let updateData = {...contentByLang};
            if(name === 'time'){
                const valid = validateOnlyIntegers(value);
                if(valid){
                    updateData[name].value = value;
                }
            }
            if(name !== 'time'){
                updateData[name].value = value;
            }
            
            let contentByLangUpdate = {...contentByLang};
            contentByLangUpdate = updateData;
            setContentByLang(contentByLangUpdate);
        }else{
            setTimezone(value);
        }

    }

    const handleCreateSegmentation = () => {
        setSegmentationOpen(!segmentationOpen);
    }

    const handleSaveVigency = () => {
        setOpenScheduleDateTimeRange(!openScheduleDateTimeRange);
    }

    const handleVigencyRange = () => {
        setVigencyDataLoaded(false);
        setOpenScheduleDateTimeRange(!openScheduleDateTimeRange);
    }
    
    const handleDeleteCoverImage = () => {
        setCroppedImage(null);
        setCoverImage(null);

        let contentByLangUpdate = {...contentByLang};
        contentByLangUpdate.image.value = "";
        setContentByLang(contentByLangUpdate);
    }

    const handleConfirmationCallback = () => {
        setLoadingForm(false);
        setConfirmationOpen(false);
        setSegmentationOpen(true);
    }

    const handleSubmitFinal = async () => {

        let segmentsUpdate = {...segments};
            segmentsUpdate.countries = [userCountrySelected.id_country];
            //setSegments({countries: [userCountrySelected.id_country]});
            setSegments(segmentsUpdate);

        let contentByLangUpdate = {...contentByLang};
            contentByLangUpdate.segments.value = segmentsUpdate;

            contentByLangUpdate.can_repeat.value = contentByLangUpdate.can_repeat.value ? true : false;
            contentByLangUpdate.one_shot.value = contentByLangUpdate.one_shot.value ? true : false;
            contentByLangUpdate.random.value = contentByLangUpdate.random.value ? true : false;

            setContentByLang(contentByLangUpdate);
        
        try{

            setErrorFormMessage({top: "", bottom: ""})
            setHaveErrorForm(false);
            setLoadingForm(true);
            await handleValidateForm();
            await handleUploadFile();
            //await handleSendForm();
            
            setInitLoadEvaluation(true);


        }catch(err){

            setErrorFormMessage({top: t("texts.Faltan los datos remarcados"), bottom: t("texts.Corrige informacion faltante o erronea marcada")})
            setHaveErrorForm(true);
            setLoadingForm(false);
            
        }
        
    }

    const handleValidateForm = () => {
        
        return new Promise((resolve, reject) => {
    
            let haveError = false;

            if(Object.keys(contentByLang).length){
                let updateContentByLangs = {...contentByLang};
                Object.keys(updateContentByLangs).map(function(key) {
                    if(updateContentByLangs[key].required){
                        if(!updateContentByLangs[key].value.length && key !== 'date_block'){
                                                            
                            if(key !== "image" && key !== 'date_init' && key !== 'date_finish' && key !== 'translations' && key !== 'date_block'){
                                haveError = true;
                                updateContentByLangs[key].error = true;
                            }

                            if(key === 'date_init' || key === 'date_finish'){
                                if(!dayjs(updateContentByLangs[key].value).isValid()){
                                    haveError = true;
                                    setVigencyDateError(true);
                                }
                            }


                        }else{
                            updateContentByLangs[key].error = false;
                            
                        }

                    }

                    if(key === 'date_block'){
                        if(!dayjs(updateContentByLangs[key].value).isValid()){
                            haveError = true;
                            updateContentByLangs[key].error = true;
                        }else{
                            if(timezone.length){
                                setTimezoneError(false);
                                if(dayjs.tz.guess() === timezone){
                                    updateContentByLangs[key].value = dayjs(dayjs(updateContentByLangs[key].value).format('YYYY-MM-DD HH:mm')).utc().toISOString();
                                }else{
                                    updateContentByLangs[key].value = dayjs.tz(dayjs(updateContentByLangs[key].value).format('YYYY-MM-DD HH:mm'), timezone).utc().toISOString();
                                }
                            }
                        }
                        if(!timezone.length){
                            haveError = true;
                            setTimezoneError(true);
                        }else{
                            setTimezoneError(false);
                        }
                    }

                    if(key === 'translations'){
                        let langsError = [];
                        Object.keys(updateContentByLangs['translations']).map(function(lang) {
                            
                            let errorByLang = false;

                            Object.keys(updateContentByLangs['translations'][lang]).map(function(key) {
                                if(updateContentByLangs['translations'][lang][key]?.required){
                                    if(!updateContentByLangs['translations'][lang][key].value.length){
                                        
                                        if(key !== "questions" && key !== 'image'){
                                            haveError = true;
                                            errorByLang = true;
                                            updateContentByLangs['translations'][lang][key].error = true;
                                        }

                                    }else{
                                        updateContentByLangs['translations'][lang][key].error = false;
                                    }   

                                    if(key == "image"){
                                        if(!updateContentByLangs['translations'][lang][key].cropped_image.length){
                                            haveError = true;
                                            errorByLang = true;
                                            updateContentByLangs['translations'][lang][key].error = true;
                                        }else{
                                            updateContentByLangs['translations'][lang][key].error = false;
                                        }
                                    }

                                }
                                
                            })

                            if(errorByLang){
                                langsError.push(lang);
                                
                            }
                            setLangHaveError(langsError);

                        })
                    }
                })

                if(startDate && endDate){
                    if(!dayjs(endDate).isAfter(dayjs(startDate))){
                        haveError = true;
                        setVigencyDateError(true);
                    }else{
                        setVigencyDateError(false);
                    }
                }

            }

            if(!haveError){
                resolve(true);
            }

            reject(new Error("error valida"));
        
        })
    
        }

    const handleCancelSubmit = () => {
        setLoadingForm(false);
    }

    const handleStartLoadTrivia = () => {
        //alert("handleStartLoadTrivia")

        let segmentsUpdate = {...segments};
            segmentsUpdate.countries = [userCountrySelected.id_country];
            //setSegments({countries: [userCountrySelected.id_country]});
            setSegments(segmentsUpdate);
            
        setConfirmationOpen(true);
        /*
        let contentByLangUpdate = {...contentByLang};
        contentByLangUpdate.segments.value = JSON.stringify(segments);
        setContentByLang(contentByLangUpdate);

        

        alert("handleStartLoadTrivia")
        */
        //handleStartLoadEvaluation();
    }

    const handleShowLanguage = (lang) => {
        if(lang !== showLanguage){
            setShowLanguage(lang);
        }else{
            setShowLanguage(null);
        }
    }

    const handleUploadFile = () => {
        
        return new Promise((resolve, reject) => {
            let count_images_to_upload = imagesToUpload();
            let count_uploaded = 0;
            if(count_images_to_upload === count_uploaded){
                resolve(true);
            }

            let updateLangs = {...contentByLang.translations};
            Object.keys(updateLangs).map(function(key_langs) {
                
                if(updateLangs[key_langs].image.cropped_image){
                    const datetime = DateTime.fromMillis(Date.now());

                    let cropped_image = updateLangs[key_langs].image.cropped_image;
                    let upload_route = null;

                    const payload = { name: "image-"+datetime.toMillis()+".jpeg",
                                      file: updateLangs[key_langs].image.cropped_image };
                    const uploadRoute = getByPassImageUploadRoute(payload);

                    uploadRoute.then((res) => {
                        upload_route = res;
                        const uploaded = uploadFile(cropped_image, upload_route);

                        uploaded.then(uploaded_res => {
                            updateLangs[key_langs].image.cropped_image = "";
                            updateLangs[key_langs].image.upload_route = "";
                            updateLangs[key_langs].image.value = uploaded_res;

                            let contentByLangUpdate = {...contentByLang};
                            contentByLangUpdate.translations[key_langs] = updateLangs[key_langs];
                            setContentByLang(contentByLangUpdate);
                            count_uploaded ++;
                            
                            if(count_images_to_upload === count_uploaded){
                                resolve(true);
                            }

                        })
                    })
                }
            })
        })
    }

    const imagesToUpload = () => {
        let count_images = 0;
        let updateLangs = {...contentByLang.translations};
        Object.keys(updateLangs).map(function(key_langs) {
            if(updateLangs[key_langs].image.cropped_image){
                count_images++;
            }
        })
        return count_images;
    }
    
    useEffect(() => {
        
        if(croppedImage){
            
            setCoverImage(croppedImage);
            let contentByLangUpdate = {...contentByLang};
            contentByLangUpdate.image.cropped_image = croppedImage;
            contentByLangUpdate.image.upload_route = uploadRoute;
            setContentByLang(contentByLangUpdate);

        }
    
        return () => {}
    }, [croppedImage])
    

    useEffect(() => {

      if(startDate){
        
        let _date_init = "";
        if(dayjs.tz.guess() === timezone){
            _date_init = dayjs(dayjs(startDate).format('YYYY-MM-DD HH:mm')).utc().toISOString();
        }else{
            _date_init = dayjs.tz(dayjs(startDate).format('YYYY-MM-DD HH:mm'), timezone).utc().toISOString();
        }
        handleFormElementChange('date_init', _date_init);
      }
    
      return () => {}
    }, [startDate])

    useEffect(() => {
        
        if(startDate){
            let _date_finish = "";
          if(dayjs.tz.guess() === timezone){
             _date_finish = dayjs(dayjs(endDate).format('YYYY-MM-DD HH:mm')).utc().toISOString();
          }else{
            _date_finish = dayjs.tz(dayjs(endDate).format('YYYY-MM-DD HH:mm'), timezone).utc().toISOString();
          }
          handleFormElementChange('date_finish', _date_finish);
        }
      
        return () => {}
    }, [endDate])

    
    useEffect(() => {
        
        if(basicData){

            const arrQuestionQuantityEval = [];
            for(let i = 2; i <= 20; i++){
                arrQuestionQuantityEval.push({_id: i, name: i});
            }
            setQuestionQuantityEval(arrQuestionQuantityEval);

            // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

            const arrQuestionQuantityToload = [];
            for(let i = scope === "edit" ? 1 : 2; i <= 100; i++){
                arrQuestionQuantityToload.push({_id: i, name: i});
            }
            setQuestionQuantityToload(arrQuestionQuantityToload);

        }
    
      return () => {}
    }, [basicData])

    useEffect(() => {
        if(userCountrySelected){
            if(userCountrySelected.languages.length){
                setShowLanguage(userCountrySelected.languages[0].language_identifier);
            }
        }
    return () => {}
    }, [userCountrySelected])
    

    useEffect(() => {
        if(contentByLang && Object.keys(contentByLang).length && userCountrySelected && scope === "edit"){
            setCountActualQuestions(contentByLang.translations[userCountrySelected.languages[0].language_identifier].questions.length);
            setStartDate(dayjs(contentByLang.date_init.value).tz(dayjs.tz.guess()).format());
            setEndDate(dayjs(contentByLang.date_finish.value).tz(dayjs.tz.guess()).format());
            setSegments(contentByLang.segments.value);
        }
        
      return () => {
        
      }
    }, [contentByLang, userCountrySelected])

    

    return (
        <WrapperStyled panColors={panColors}>

            {openModalImage &&
                <ModalImage 
                    openModalImage={openModalImage} 
                    setOpenModalImage={setOpenModalImage} 
                    croppedImage={croppedImage}
                    setCroppedImage={setCroppedImage}
                    uploadRoute={uploadRoute}
                    setUploadRoute={setUploadRoute}
                    scope={"cover_image"}
                    maxSize={""}
                />
            }

            {!vigencyDataLoaded ? 
            <ScheduleDateTimeRange 
                startDate={startDate}
                setStartDate={setStartDate}
                endDate={endDate}
                setEndDate={setEndDate} 
                open={openScheduleDateTimeRange} 
                setOpen={setOpenScheduleDateTimeRange}
                handleSubmit={handleSaveVigency}
                timezone={timezone}
                setTimezone={setTimezone}
                title={"texts.Vigencia de la trivia"}
                description={"texts.Planifica la duracion de la trivia en una fechar determinada"}
            /> : ""}

            <Confirmation 
                open={confirmationOpen} 
                setOpen={setConfirmationOpen}
                type={'course'}
                data={segments}
                segments={segments}
                setSegments={setSegments}
                noSegments={noSegments}
                setNoSegments={setNoSegments}
                handleCallback={handleConfirmationCallback}
                handleSubmit={handleSubmitFinal}
                handleCancelSubmit={handleCancelSubmit}
                //description={t("texts.El beneficio sera publicado el", {date: immediatePublication ? dayjs().format('YYYY-MM-DD HH:mm') : dayjs(publicationDate).format('YYYY-MM-DD HH:mm')})}
                description={'descripcion'}
            />

            <Segmentation 
                open={segmentationOpen} 
                setOpen={setSegmentationOpen}
                segments={segments}
                setSegments={setSegments}
            />

            <div className="box_form">
                <div className="box_column">
                    <div className="box_fields">
                        <div className="title">
                            {t("texts.Datos de la trivia")}
                        </div>

                        <SelectCustom 
                            name={contentByLang?.count_questions?.ref}
                            label={t("texts."+contentByLang?.count_questions?.label)}
                            placeholder={t("texts."+contentByLang?.count_questions?.placeholder)}
                            onChange={handleFormElementChange}
                            className={`field field_${contentByLang?.count_questions?.ref}${contentByLang?.count_questions?.error ? " error" : ""}`}
                            type="text"
                            value={contentByLang?.count_questions?.value}
                            help={t("texts.Min. Max Preguntas", {min: 2, max: 15})}
                            isRequired={contentByLang?.count_questions?.required}
                            disabled={contentByLang?.question_quantity_toload?.disabled}
                            styles={ formStyle }
                            label_icon={<CoursesMenuIcon />}
                            tooltip_content={contentByLang?.count_questions?.tooltip ? t("texts."+contentByLang?.count_questions?.tooltip) : ""}
                            haveError={contentByLang?.count_questions?.error}
                            data={questionQuantityEval}
                        />

                        <SelectCustom 
                            name={contentByLang?.question_quantity_toload?.ref}
                            label={t("texts."+contentByLang?.question_quantity_toload?.label)}
                            placeholder={t("texts."+contentByLang?.question_quantity_toload?.placeholder)}
                            onChange={handleFormElementChange}
                            className={`field field_${contentByLang?.question_quantity_toload?.ref}${contentByLang?.question_quantity_toload?.error ? " error" : ""}`}
                            type="text"
                            value={contentByLang?.question_quantity_toload?.value}
                            help={t("texts.Min. Max Preguntas", {min: 2, max: 100})}
                            isRequired={contentByLang?.question_quantity_toload?.required}
                            disabled={contentByLang?.question_quantity_toload?.disabled}
                            styles={ formStyle }
                            label_icon={<CountIcon />}
                            tooltip_content={contentByLang?.question_quantity_toload?.tooltip ? t("texts."+contentByLang?.question_quantity_toload?.tooltip) : ""}
                            haveError={contentByLang?.question_quantity_toload?.error}
                            data={questionQuantityToload}
                        />
                        
                        
                        <div className='field_single'>
                        <InputCustom 
                            name={contentByLang?.time?.ref}
                            label={t("texts."+contentByLang?.time?.label)}
                            placeholder={t("texts."+contentByLang?.time?.placeholder)}
                            onChange={handleFormElementChange}
                            onKeyDown={null}
                            className={`field field_${contentByLang?.time?.ref}${contentByLang?.time?.error ? " error" : ""}`}
                            type="text"
                            value={contentByLang?.time?.value}
                            help={contentByLang?.time?.help}
                            isRequired={contentByLang?.time?.required}
                            styles={ formStyle }
                            label_icon={null}
                            tooltip_content={null}
                            haveError={contentByLang?.time?.error}
                        />
                        </div>
                        
                        <div className='field_single field_date_block'>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <div className="field file_publication_date">
                                    <LabelCustom 
                                        name="label_activate_at"
                                        label={t("texts.Fecha fin de trivia")}
                                        onChange={handleFormElementChange}
                                        className="field field_activate_at"
                                        styles={ formStyle }
                                        label_icon={<CalendarMonthIcon />}
                                    />
                                    <DateTimePicker
                                        ampm={false}
                                        className={`datetime_activate_at ${contentByLang?.date_block?.error ? " error" : ""}`}
                                        disableFuture={false}
                                        disablePast={scope === "edit" ? false : true} // Disable automatic validation of past dates
                                        timezone="America/Argentina/Buenos_Aires"
                                        value={contentByLang?.date_block?.value ? dayjs(contentByLang?.date_block?.value) : null}
                                        onChange={(newValue) => handleFormElementChange('date_block', newValue)}
                                        disabled={false}
                                    />
                                </div>
                            </LocalizationProvider>
                            <SelectCustom 
                                name={"timezone"}
                                label={""}
                                placeholder={t("texts.Seleccionar zona horaria") + "..."}
                                onChange={handleFormElementChange}
                                //onChange={(newValue) => setTimezone(newValue)}
                                className={`field field_timezone ${timezoneError ? " error" : ""}`}
                                type="text"
                                value={timezone}
                                help={null}
                                isRequired={false}
                                styles={ formStyle }
                                label_icon={<FilterAltIcon />}
                                tooltip_content={null}
                                haveError={false}
                                data={basicData?.valoresUTC}
                            />
                        </div>

                        {/* <InputCustom 
                            name={contentByLang?.name?.ref}
                            label={t("texts."+contentByLang?.name?.label)}
                            placeholder={t("texts."+contentByLang?.name?.placeholder)}
                            onChange={handleFormElementChange}
                            onKeyDown={null}
                            className={`field field_${contentByLang?.name?.ref}${contentByLang?.name?.error ? " error" : ""}`}
                            type="text"
                            value={contentByLang?.name?.value}
                            help={contentByLang?.name?.help}
                            isRequired={contentByLang?.name?.required}
                            styles={ formStyle }
                            label_icon={<TitleIcon />}
                            tooltip_content={contentByLang?.name?.tooltip ? t("texts."+contentByLang?.name?.tooltip) : ""}
                            haveError={contentByLang?.name?.error}
                        />

                        <div className="box_field_description_short">
                            <TextareaCustom 
                                name={contentByLang?.description?.ref}
                                label={t("texts."+contentByLang?.description?.label)}
                                placeholder={t("texts."+contentByLang?.description?.placeholder)}
                                onChange={handleFormElementChange}
                                onKeyDown={null}
                                className={`field field_${contentByLang?.description?.ref}${contentByLang?.description?.error ? " error" : ""}`}
                                type="text"
                                value={contentByLang?.description?.value}
                                help={""}
                                isRequired={contentByLang?.description?.required}
                                styles={ formStyle }
                                label_icon={<HeadlineIcon />}
                                tooltip_content={contentByLang?.description?.tooltip ? t("texts."+contentByLang?.description?.tooltip) : ""}
                                haveError={contentByLang?.description?.error}
                            />
                        </div>

                        <div className="box_cover_image">
                            {coverImage ?
                            <div className={`image ${contentByLang?.cover_image?.error ? " error" : ""}`}>
                                <img src={coverImage} />
                            </div>
                            :
                            <div className={`image_thumb ${contentByLang?.cover_image?.error ? " error" : ""}`}>
                                <div className="icon">
                                    <ImageIcon />
                                </div>
                            </div>
                            }
                            <div className="add_image">
                                {!coverImage &&
                                    <ButtonTextCustom 
                                        className={`bt_add_image${loadingForm ? " is_loading" : ""}`}
                                        text={t("texts.+ Agregar / Modificar imagen de Voucher") + " *"}
                                        onClick={() => setOpenModalImage(true)}

                                        icon={null}
                                        background={{ normal: "", hover: "" }}
                                        border={{ normal: "", hover: "" }}
                                        textcolor={{ normal: panColors.primary, hover: panColors.primary }}
                                    />
                                }
                                {coverImage &&
                                    <ButtonTextCustom 
                                        className={`bt_delete_image${loadingForm ? " is_loading" : ""}`}
                                        text={t("texts.Borrar")}
                                        onClick={() => handleDeleteCoverImage()}

                                        icon={<TrashIcon />}
                                        background={{ normal: "", hover: "" }}
                                        border={{ normal: "", hover: "" }}
                                        textcolor={{ normal: panColors.red, hover: panColors.red }}
                                    />
                                }
                            </div>
                        </div> */}

                        {/* {Object.keys(startDate).length ?
                        <ActionBox 
                            className="action_box_segmentation"
                            icon={<CalendarMonthIcon />}
                            title={"Vigencia del beneficio *"}
                            actionButtonText={"Editar Vigencia"}
                            helpText={`Vigencia establecida del ${(startDate && endDate) ? dayjs(startDate).format('YYYY-MM-DD HH:mm') + ' al ' + dayjs(endDate).format('YYYY-MM-DD HH:mm') : '...'}`}
                            onClick={handleVigencyRange}
                            error={vigencyDateError}
                        /> : ""} */}

                    </div>
                </div>
                <div className="box_column">
                    <div className="box_fields">

                        <div className="retries">
                            <LabelCustom 
                                name={"retries"}
                                label={t("texts.Reintentos en esta trivia") + " *"}
                                styles={ formStyle }
                                label_icon={<FormatListNumberedIcon />}
                                isRequired={false}
                                tooltip_content={""}
                            />
                            <InputCheckboxCustom
                                name={contentByLang?.can_repeat?.ref}
                                label={t("texts."+contentByLang?.can_repeat?.label)}
                                placeholder={t("texts."+contentByLang?.can_repeat?.placeholder)}
                                onChange={handleFormElementChange}
                                className={`field field_${contentByLang?.can_repeat?.ref}${contentByLang?.can_repeat?.error ? " error" : ""}`}
                                value={contentByLang?.can_repeat?.value}
                                help={contentByLang?.can_repeat?.help}
                                isRequired={contentByLang?.can_repeat?.required}
                                styles={ formStyle }
                                label_icon={null}
                                labelPosition={"right"}
                                tooltip_content={null}
                                haveError={contentByLang?.can_repeat?.error}
                            />

                            <InputCheckboxCustom
                                name={contentByLang?.one_shot?.ref}
                                label={t("texts."+contentByLang?.one_shot?.label)}
                                placeholder={t("texts."+contentByLang?.one_shot?.placeholder)}
                                onChange={handleFormElementChange}
                                className={`field field_${contentByLang?.one_shot?.ref}${contentByLang?.one_shot?.error ? " error" : ""}`}
                                value={contentByLang?.one_shot?.value}
                                help={contentByLang?.one_shot?.help}
                                isRequired={contentByLang?.one_shot?.required}
                                styles={ formStyle }
                                label_icon={null}
                                labelPosition={"right"}
                                tooltip_content={null}
                                haveError={contentByLang?.one_shot?.error}
                            />

                            <InputCheckboxCustom
                                name={contentByLang?.random?.ref}
                                label={t("texts."+contentByLang?.random?.label)}
                                placeholder={t("texts."+contentByLang?.random?.placeholder)}
                                onChange={handleFormElementChange}
                                className={`field field_${contentByLang?.random?.ref}${contentByLang?.random?.error ? " error" : ""}`}
                                value={contentByLang?.random?.value}
                                help={contentByLang?.random?.help}
                                isRequired={contentByLang?.random?.required}
                                styles={ formStyle }
                                label_icon={null}
                                labelPosition={"right"}
                                tooltip_content={null}
                                haveError={contentByLang?.random?.error}
                            />
                        </div>

                        <ActionBox 
                            className="action_box_segmentation"
                            icon={<SegmentarionIcon />}
                            title={t("texts.Segmentacion") + " *"}
                            actionButtonText={t("texts.Crear Segmentacion")}
                            helpText={t("texts.Volver a la pantalla de segmentacion para editar")}
                            onClick={handleCreateSegmentation}
                        /> 

                        <ActionBox 
                            className="action_box_vigency"
                            icon={<CalendarMonthIcon />}
                            title={t("texts.Vigencia de la trivia") + " *"}
                            actionButtonText={t("Editar Vigencia")}
                            helpText={t("texts.Vigencia establecida del", {from: startDate && dayjs(startDate).format('YYYY-MM-DD HH:mm') ? dayjs(startDate).format('YYYY-MM-DD HH:mm') : "...", to: endDate && dayjs(endDate).format('YYYY-MM-DD HH:mm') ? dayjs(endDate).format('YYYY-MM-DD HH:mm') : "..."})}
                            //helpText={`Vigencia establecida del ${(startDate && endDate) ? dayjs(startDate).format('YYYY-MM-DD HH:mm') + ' al ' + dayjs(endDate).format('YYYY-MM-DD HH:mm') : '...'}`}
                            onClick={handleVigencyRange}
                            error={vigencyDateError}
                        />

                        <div className='vigency_warning_text'>
                            <div className='icon'>
                                <RiErrorWarningLine />
                            </div>
                            <p>{t("texts.Aplica al periodo durante el cual el ranking es visible y al inicio de la trivia")}</p>
                        </div>
                    </div>
                </div>
            </div>
            
            {userCountrySelected?.languages?.length ? 
            <>
                <FormTopMessage 
                    haveError={haveErrorForm}
                    text={errorFormMessage.top}
                />

                {
                    userCountrySelected?.languages.map((lang, index) => {
                        return(
                            <div className={`box_lang ${userCountrySelected?.languages?.length > 1 ? " multilang" : ""}${(langHaveError.filter(langerror => langerror === lang.language_identifier).length ? ' error' : '')}${showLanguage === lang.language_identifier ? ' open' : ''}`}>
                                {userCountrySelected?.languages?.length > 1 &&
                                <div className="head_form_lang">
                                    <div className="title">
                                        <div className="icon">
                                            <LanguageIcon />
                                        </div>
                                        <div className="text">
                                            {t("texts.Beneficio en")} { getNameLanguage(userCountrySelected?.languages, lang.language_identifier) }
                                        </div>
                                    </div>
                                    {userCountrySelected?.languages.length ?
                                    <ButtonTextCustom 
                                        className="bt_show_more_info"
                                        text={`${showLanguage === lang.language_identifier ? t("texts.Cerrar") : t("texts.Abrir")}`}
                                        onClick={() => handleShowLanguage(lang.language_identifier)}

                                        icon={<BiSolidDownArrow />}
                                        background={{ normal: "", hover: "" }}
                                        border={{ normal: "", hover: "" }}
                                        textcolor={{ normal: panColors.primary, hover: panColors.primary }}
                                    /> : "" }
                                </div>
                                }

                                <FormData 
                                    className={`content_form${showLanguage === lang.language_identifier ? ' show' : ' hide'}`}
                                    lang={lang.language_identifier}
                                    data={contentByLang.translations[lang.language_identifier]}
                                    contentByLang={contentByLang}
                                    setContentByLang={setContentByLang}
                                />
                                {/* <div className={`content_form${showLanguage === lang.language_identifier ? ' show' : ' hide'}`}>
                                    
                                    <div className='inner_form'>
                                        <div className="box_form">
                                            <div className="box_column">

                                                <div className="box_cover_image">
                                                    {coverImage ?
                                                    <div className={`image ${contentByLang?.cover_image?.error ? " error" : ""}`}>
                                                        <img src={coverImage} />
                                                    </div>
                                                    :
                                                    <div className={`image_thumb ${contentByLang?.cover_image?.error ? " error" : ""}`}>
                                                        <div className="icon">
                                                            <ImageIcon />
                                                        </div>
                                                    </div>
                                                    }
                                                    <div className="add_image">
                                                        {!coverImage &&
                                                            <ButtonTextCustom 
                                                                className={`bt_add_image${loadingForm ? " is_loading" : ""}`}
                                                                text={t("texts.+ Agregar / Modificar imagen de Voucher") + " *"}
                                                                onClick={() => setOpenModalImage(true)}

                                                                icon={null}
                                                                background={{ normal: "", hover: "" }}
                                                                border={{ normal: "", hover: "" }}
                                                                textcolor={{ normal: panColors.primary, hover: panColors.primary }}
                                                            />
                                                        }
                                                        {coverImage &&
                                                            <ButtonTextCustom 
                                                                className={`bt_delete_image${loadingForm ? " is_loading" : ""}`}
                                                                text={t("texts.Borrar")}
                                                                onClick={() => handleDeleteCoverImage()}

                                                                icon={<TrashIcon />}
                                                                background={{ normal: "", hover: "" }}
                                                                border={{ normal: "", hover: "" }}
                                                                textcolor={{ normal: panColors.red, hover: panColors.red }}
                                                            />
                                                        }
                                                    </div>
                                                </div>

                                                <InputCustom 
                                                    name={contentByLang?.name?.ref}
                                                    label={t("texts."+contentByLang?.name?.label)}
                                                    placeholder={t("texts."+contentByLang?.name?.placeholder)}
                                                    onChange={handleFormElementChange}
                                                    onKeyDown={null}
                                                    className={`field field_${contentByLang?.name?.ref}${contentByLang?.name?.error ? " error" : ""}`}
                                                    type="text"
                                                    value={contentByLang?.name?.value}
                                                    help={contentByLang?.name?.help}
                                                    isRequired={contentByLang?.name?.required}
                                                    styles={ formStyle }
                                                    label_icon={<TitleIcon />}
                                                    tooltip_content={contentByLang?.name?.tooltip ? t("texts."+contentByLang?.name?.tooltip) : ""}
                                                    haveError={contentByLang?.name?.error}
                                                />

                                                <div className="box_field_description_short">
                                                    <TextareaCustom 
                                                        name={contentByLang?.description?.ref}
                                                        label={t("texts."+contentByLang?.description?.label)}
                                                        placeholder={t("texts."+contentByLang?.description?.placeholder)}
                                                        onChange={handleFormElementChange}
                                                        onKeyDown={null}
                                                        className={`field field_${contentByLang?.description?.ref}${contentByLang?.description?.error ? " error" : ""}`}
                                                        type="text"
                                                        value={contentByLang?.description?.value}
                                                        help={""}
                                                        isRequired={contentByLang?.description?.required}
                                                        styles={ formStyle }
                                                        label_icon={<HeadlineIcon />}
                                                        tooltip_content={contentByLang?.description?.tooltip ? t("texts."+contentByLang?.description?.tooltip) : ""}
                                                        haveError={contentByLang?.description?.error}
                                                    />
                                                </div>
                                                
                                            </div>
                                        </div>
                                    </div>


                                </div> */}
                            </div>
                        )
                    })
                }
            </>
            : ""}

            <div className="actions">
                {!loadingForm ? 
                    <>
                        <ButtonCustom 
                            className="bt_submit"
                            text={t("texts.Comenzar a cargar la trivia")}
                            onClick={handleStartLoadTrivia}
                            style_type="normal"
                            
                            icon={null}
                            background={{ normal: panColors.primary, hover: panColors.white }}
                            border={{ normal: panColors.primary, hover: panColors.primary }}
                            textcolor={{ normal: panColors.white, hover: panColors.primary }}
                        />
                        <ButtonTextCustom 
                            className="bt_cancel"
                            text={t("texts.Cancelar")}
                            onClick={handleCancel}

                            icon={null}
                            background={{ normal: "", hover: "" }}
                            border={{ normal: "", hover: "" }}
                            textcolor={{ normal: panColors.red, hover: panColors.red }}
                        />
                    </>
                : 
                    <div className='loader'>
                        <LoaderComponent size={25} color={panColors.primary} />
                    </div>
                }
            </div>

        </WrapperStyled>
    );
}

export default React.memo(Form);